


































































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import { Datetime } from 'vue-datetime';
import { IPaymentMethod } from '@/interfaces';
import { dispatchGetAvailablePaymentMethods } from '@/store/main/actions';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
    Datetime,
  },
})
export default class DonationModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;

  public formError = false;
  public category: number | null = null;
  public country: string = '';
  public paymentMethod: number | null = null;
  public amount: number = 0;
  public createdAt: any = '';
  public attachment: any = null;
  public loadingState = {
    submit: false,
  };
  public paymentMethods: IPaymentMethod[] = [];
  public step: number = 1;

  public mounted() {
    if (this.userProfile && this.userProfile.country_with_flag) {
      this.country = this.userProfile.country_with_flag;
    }
  }

  public validateForm() {
    if (this.step === 1) {
      if (!this.category || !this.paymentMethod || !this.country) {
        this.formError = true;
        // @ts-ignore
        this.showToast(this, this.$t('Please, fill all fields'), 'error');
        return false;
      } else {
        this.formError = false;
        return true;
      }
    } else {
      if (
        !this.amount || !this.attachment || !this.category ||
        !this.paymentMethod || !this.country || !this.createdAt
      ) {
        this.formError = true;
        // @ts-ignore
        this.showToast(this, this.$t('Please, fill all fields'), 'error');
        return false;
      } else if (new Date(this.createdAt) > new Date()) {
        this.formError = true;
        // @ts-ignore
        this.showToast(this, this.$t('Payment date and time is invalid'), 'error');
        return false;
      } else {
        this.formError = false;
        return true;
      }
    }
  }

  public resetForm() {
    this.step = 1;
    this.amount = 0;
    this.attachment = null;
    this.category = null;
    this.country = '';
    this.paymentMethod = null;
    this.createdAt = '';
    this.$emit('close-modal');
  }

  public async handleConfirmStep() {
    if (await this.validateForm()) {
      this.step = 2;
    }
  }

  public async handleSubmit() {
    if (await this.validateForm()) {
      try {
        const formData = new FormData();
        formData.append('type', '1');
        // @ts-ignore
        formData.append('user', this.userProfile.id);
        formData.append('users', JSON.stringify([]));
        // @ts-ignore
        formData.append('amount', this.amount);
        formData.append('attachment', this.attachment);
        // @ts-ignore
        formData.append('category', this.category);
        // @ts-ignore
        formData.append('payment_method', this.paymentMethod);
        formData.append('created_at', this.createdAt);

        const response = await api.submitUserDonation(
          this.$store.getters.token, formData,
        );
        // @ts-ignore
        this.showToast(this, this.$t('Donation created'));
        this.$emit('created-event');
        this.resetForm();
      } catch (error) {
        if (error.response.data) {
          let errorMsg = '';
          for (const [key, value] of Object.entries(error.response.data)) {
            // @ts-ignore
            errorMsg += `${this.$t(key)} - ${value[0]}\n`;
          }
          // @ts-ignore
          this.showToast(this, errorMsg, 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public handleChangeCategory(value) {
    this.category = value;
    this.handleUpdatePaymentMethods();
  }

  public handleChangeCountry(value) {
    this.country = value;
    this.handleUpdatePaymentMethods();
  }

  public async handleUpdatePaymentMethods() {
    this.paymentMethod = null;
    if (this.category && this.country) {
      this.paymentMethods = await dispatchGetAvailablePaymentMethods(
          this.$store, {category: this.category, country: this.country},
      );
    }
  }

  get payMethods() {
    const payMethods: any = [];
    if (this.paymentMethods) {
      for (const [key, value] of Object.entries(this.paymentMethods)) {
        payMethods.push({
          value: value.id, text: value.title,
        });
      }
    }
    return payMethods;
  }

  get paymentMethodDetails() {
    let result = '';
    if (this.paymentMethod) {
      for (const [key, value] of Object.entries(this.paymentMethods)) {
        if (value.id === this.paymentMethod) {
          result = value.props;
        }
      }
    }
    return result;
  }

  // get payMethods() {
    // return [
    //   {
    //     value: 'A',
    //     text: this.$t('Cash'),
    //   },
    //   {
    //     value: 'U',
    //     text: 'Western Union',
    //   },
    //   {
    //     value: 'V',
    //     text: 'Visa/MasterCard',
    //   },
    // ];
  // }

}
